/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type BookabilityCardVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  inService: boolean | null
  notInServiceReasons: Array<Types.NotInServiceReason> | null
  pooling: {
    __typename?: 'Pooling'
    enabled: boolean
    enabledUpdatedAt: string | null
    reason: Types.PoolingReason | null
  } | null
}

export const BookabilityCardVehicleFragmentDoc = gql`
    fragment BookabilityCardVehicle on Vehicle {
  id
  pooling {
    enabled
    enabledUpdatedAt
    reason
  }
  inService
  notInServiceReasons
}
    `
